<template>
  <div class="create-team-limit-modal">
    <div>
      <Alert type="warning">
        {{
          $t(
            'mei-ge-yong-hu-zui-duo-ke-guan-li-1-ge-ti-yan-ban-tuan-dui-zhang-hao-nin-dang-qian-yi-yong-you-2-ge-zan-wu-fa-chuang-jian-xin-de-tuan-dui-nin-ke-yi-qie-huan-ti-yan-ban-zhang-hao-jin-hang-ti-yan-huo-zhe-sheng-ji-tuan-dui-jie-suo-geng-duo-quan-yi',
          )
        }}
      </Alert>
    </div>
    <h3>{{ $t('nin-dang-qian-de-qi-ye-ti-yan-ban-bao-kuo') }}</h3>
    <div>
      <div v-for="item in displayAccountList" :key="item.id">
        <AccountItem
          :account="{
            isAdmin: item.permission !== USER_ADMIN.NORMAL,
            teamName: item.org_name,
            accountName: item.name,
            logoUrl: item.logo_url,
            isIdentify: item.is_identify,
            rightsType: item.rights_type,
          }"
          @click="handleSwitchAccount(item)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Account } from '@rendora/common/entities/user';
import { useUserStore } from '@rendora/common/store';
import { IRightsType, USER_ADMIN } from '@rendora/common/types/enums';
import { sessionSetItem } from '@rendora/common/utils/webStorage';
import { Alert } from '@rendora/design/components/alert/index';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import AccountItem from './AccountItem.vue';

const userStore = useUserStore();

const { accountList } = storeToRefs(userStore);

const displayAccountList = computed(() => {
  return accountList.value.filter(item => {
    return (
      Number(item.rights_type) === IRightsType.TEAM_TASTE &&
      Number(item.permission) !== USER_ADMIN.NORMAL
    );
  });
});

const handleSwitchAccount = (account: Account) => {
  userStore.switchAccount(account);
  sessionSetItem('showRightCompareModal', true);
};
</script>

<style scoped lang="scss">
.create-team-limit-modal {
  padding: 24px 20px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: var(--x-text-1);
  }
}
</style>
